import { createContext, useContext, useLayoutEffect } from 'react';
/**
 * Presente dentro una `SheetView` che non ha un titolo proprio (`title`,
 * `hasTitle`): la testata del pannello (`SheetTopBar`) rende il suo titolo
 * come `SheetTitle` e il fallback sr-only «Pannello» sparisce.
 */
export const SheetTitleSlotContext = createContext(null);
/**
 * `true` se il titolo del chiamante diventa il nome del pannello. Con
 * `enabled` falso (es. titolo ancora vuoto durante il caricamento) non
 * registra nulla: il pannello tiene il proprio nome di ripiego.
 */
export function useSheetTitleSlot(enabled = true) {
    const register = useContext(SheetTitleSlotContext);
    const activeRegister = enabled ? register : null;
    useLayoutEffect(() => activeRegister?.(), [activeRegister]);
    return activeRegister !== null;
}
//# sourceMappingURL=sheet-title-slot.js.map